import React from 'react';

const ChildTableContext = React.createContext();
export default ChildTableContext;
